import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m2.648-7.102-3 3a.56.56 0 0 1-.794 0l-1.5-1.5a.562.562 0 0 1 .795-.795L7.25 8.706l2.602-2.603a.562.562 0 0 1 .795.795z"
    }, null, -1)
  ]))]))
}
export default { render: render }